"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _PasswordChecklist = _interopRequireDefault(require("../PasswordChecklist"));
var _PasswordVisibility = _interopRequireDefault(require("../PasswordVisibility"));
var _fieldStyledComponents = require("../../styles/styled-components/field-styled-components");
var _styles = require("./styles");
var _class, _FieldComponent;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FieldComponent = (0, _reactClickOutside["default"])(_class = (_FieldComponent = /*#__PURE__*/function (_Component) {
  function FieldComponent(props) {
    var _this;
    _classCallCheck(this, FieldComponent);
    _this = _callSuper(this, FieldComponent, [props]);
    _defineProperty(_this, "togglePassword", function () {
      return _this.setState({
        showPassword: !_this.state.showPassword
      });
    });
    _defineProperty(_this, "toggleEditMode", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !_this.state.editMode;
      var _this$props = _this.props,
        _this$props$readOnly = _this$props.readOnly,
        readOnly = _this$props$readOnly === void 0 ? false : _this$props$readOnly,
        shadowText = _this$props.shadowText,
        field = _this$props.field;
      if (readOnly) return;
      _this.setState({
        editMode: value
      });
      if (shadowText && value) {
        var input = document.getElementById("".concat(field, "-inline-input"));
        input && input.focus();
      }
    });
    _defineProperty(_this, "inputId", _this.props.inputId || (0, _uniqueId["default"])('field-'));
    _defineProperty(_this, "handleInputKeydown", function (event) {
      var _this$props2 = _this.props,
        onSubmit = _this$props2.onSubmit,
        onCancel = _this$props2.onCancel;
      if (!_this.state.editMode) return;
      if (onSubmit && event.keyCode === 13) {
        onSubmit();
        _this.toggleEditMode();
      }
      if (onCancel && event.keyCode === 27) {
        onCancel();
        _this.toggleEditMode();
      }
    });
    _defineProperty(_this, "handleClickOutside", function () {
      var _this$props3 = _this.props,
        shadowText = _this$props3.shadowText,
        _this$props3$inline = _this$props3.inline,
        inline = _this$props3$inline === void 0 ? false : _this$props3$inline,
        onSubmit = _this$props3.onSubmit;
      if (_this.state.editMode && inline && onSubmit) {
        onSubmit();
        _this.toggleEditMode();
      } else if (_this.state.editMode && shadowText) {
        _this.toggleEditMode();
      }
    });
    _this.state = {
      editMode: false,
      showPassword: false
    };
    return _this;
  }
  _inherits(FieldComponent, _Component);
  return _createClass(FieldComponent, [{
    key: "render",
    value: function render() {
      var _value$length,
        _value$length2,
        _this2 = this;
      var _this$props4 = this.props,
        autoComplete = _this$props4.autoComplete,
        autofocus = _this$props4.autofocus,
        className = _this$props4.className,
        customError = _this$props4.customError,
        dataCy = _this$props4.dataCy,
        defaultValue = _this$props4.defaultValue,
        disabled = _this$props4.disabled,
        field = _this$props4.field,
        forcedError = _this$props4.forcedError,
        form = _this$props4.form,
        inline = _this$props4.inline,
        inputComponent = _this$props4.inputComponent,
        inputType = _this$props4.inputType,
        max = _this$props4.max,
        min = _this$props4.min,
        readOnly = _this$props4.readOnly,
        placeholder = _this$props4.placeholder,
        size = _this$props4.size,
        shadowText = _this$props4.shadowText,
        styles = _this$props4.styles,
        title = _this$props4.title,
        titleDescription = _this$props4.titleDescription,
        icon = _this$props4.icon,
        width = _this$props4.width,
        display = _this$props4.display,
        customErrorStyle = _this$props4.customErrorStyle,
        dataTestId = _this$props4.dataTestId,
        hideError = _this$props4.hideError,
        onlyIntegers = _this$props4.onlyIntegers,
        withPasswordValidation = _this$props4.withPasswordValidation,
        withPasswordToggle = _this$props4.withPasswordToggle,
        name = _this$props4.name,
        value = _this$props4.value,
        onChange = _this$props4.onChange,
        onFocus = _this$props4.onFocus,
        onBlur = _this$props4.onBlur,
        error = _this$props4.error,
        isInputFocused = _this$props4.isInputFocused,
        maxFeedbackLength = _this$props4.maxFeedbackLength;
      var type = this.props.type;
      var isInputWithShadowText = shadowText && (shadowText.beforeInput || shadowText.afterInput);
      var isUnderlinedTextbox = !isInputWithShadowText && !inputComponent && inline;
      var isTextarea = !isInputWithShadowText && !isUnderlinedTextbox && !inputComponent && inputType === 'textarea';
      var isInput = !isInputWithShadowText && !isUnderlinedTextbox && !inputComponent && inputType === 'input';
      var inputError = error || forcedError;
      if (this.state.showPassword) {
        type = 'input';
      }
      return /*#__PURE__*/_react["default"].createElement(_styles.Field, _extends({
        size: size,
        className: className,
        inline: inline,
        editMode: this.state.editMode,
        "data-cy": dataCy
      }, inline && {
        onClick: this.toggleEditMode
      }, {
        display: display,
        withPasswordValidation: withPasswordValidation,
        hideArrows: this.props.hideArrows
      }), title && /*#__PURE__*/_react["default"].createElement(_fieldStyledComponents.Title, {
        htmlFor: this.inputId,
        style: styles.Title
      }, title, titleDescription && icon), inputComponent, isTextarea && /*#__PURE__*/_react["default"].createElement(_styles.InputWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.TextArea, _extends({
        id: this.inputId,
        readOnly: this.readOnly,
        styles: styles.Input,
        placeholder: placeholder,
        autoComplete: autoComplete,
        autoFocus: autofocus
      }, onChange && {
        onChange: onChange
      }, {
        defaultValue: defaultValue,
        name: name,
        value: value
      })), maxFeedbackLength && /*#__PURE__*/_react["default"].createElement(_styles.CharactersInfo, null, (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/", maxFeedbackLength)), isInput && /*#__PURE__*/_react["default"].createElement(_styles.InputWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.Input, _extends({
        id: this.inputId,
        readOnly: readOnly,
        styles: styles.Input,
        type: type,
        min: min,
        max: max,
        disabled: disabled,
        placeholder: placeholder,
        autoComplete: autoComplete,
        "data-cy": dataCy,
        "data-testid": dataTestId,
        autoFocus: autofocus
      }, onChange && {
        onChange: onChange
      }, {
        defaultValue: defaultValue,
        width: width,
        onKeyPress: function onKeyPress(e) {
          var isMatch = e.key === ',' || e.key === '.' || e.key.toLowerCase() === 'e' || e.key === '+' || e.key === '-';
          if (onlyIntegers && isMatch) {
            e.preventDefault();
          }
        },
        withPasswordValidation: withPasswordValidation,
        name: name,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        isInputFocused: isInputFocused
      })), withPasswordToggle && /*#__PURE__*/_react["default"].createElement(_styles.VisibilityIconWrapper, null, /*#__PURE__*/_react["default"].createElement(_PasswordVisibility["default"], {
        togglePassword: this.togglePassword,
        showPassword: this.state.showPassword,
        password: form.$(field).value
      })), withPasswordValidation && /*#__PURE__*/_react["default"].createElement(_PasswordChecklist["default"], {
        password: form.$(field).value,
        isInputFocused: isInputFocused
      }), maxFeedbackLength && /*#__PURE__*/_react["default"].createElement(_styles.CharactersInfo, null, (_value$length2 = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length2 !== void 0 ? _value$length2 : 0, "/", maxFeedbackLength)), isUnderlinedTextbox && /*#__PURE__*/_react["default"].createElement(_styles.InlineInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.InlineInput, _extends({
        id: this.inputId,
        onKeyDown: this.handleInputKeydown,
        readOnly: readOnly || !this.state.editMode,
        style: styles.Input
      }, (autofocus || this.state.editMode) && {
        autofocus: true
      }, {
        name: name,
        value: value,
        onChange: onChange
      })), !readOnly && icon), isInputWithShadowText && /*#__PURE__*/_react["default"].createElement(_styles.InputWithShadowText, {
        onClick: function onClick() {
          return _this2.toggleEditMode(true);
        },
        focus: this.state.editMode
      }, shadowText.beforeInput && /*#__PURE__*/_react["default"].createElement(_styles.ShadowText, null, shadowText.beforeInput), /*#__PURE__*/_react["default"].createElement(_styles.InlineInput, _extends({
        id: this.inputId,
        readOnly: readOnly,
        styles: styles.Input,
        disabled: disabled,
        placeholder: placeholder,
        autoComplete: autoComplete,
        autoFocus: autofocus
      }, onChange && {
        onChange: onChange
      }, {
        defaultValue: defaultValue,
        name: name,
        value: value
      })), shadowText.afterInput && /*#__PURE__*/_react["default"].createElement(_styles.ShadowText, {
        style: {
          marginLeft: '-3px'
        }
      }, shadowText.afterInput)), !disabled && !hideError && !withPasswordValidation && /*#__PURE__*/_react["default"].createElement(_fieldStyledComponents.Error, _extends({
        inline: inline,
        visible: customError || !!inputError && inputError !== 'validating...'
      }, customErrorStyle), inputError || error));
    }
  }]);
}(_react.Component), _defineProperty(_FieldComponent, "defaultProps", {
  autoComplete: 'on',
  autofocus: false,
  customError: '',
  inline: false,
  inputType: 'input',
  min: 0,
  readOnly: false,
  styles: {},
  type: 'text'
}), _defineProperty(_FieldComponent, "propTypes", {
  autoComplete: _propTypes["default"].string,
  autofocus: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  customError: _propTypes["default"].string,
  dataCy: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  field: _propTypes["default"].string,
  forcedError: _propTypes["default"].string,
  form: _propTypes["default"].object,
  inline: _propTypes["default"].bool,
  inputComponent: _propTypes["default"].element,
  inputType: _propTypes["default"].string,
  icon: _propTypes["default"].element,
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  shadowText: _propTypes["default"].object,
  size: _propTypes["default"].string,
  styles: _propTypes["default"].object,
  title: _propTypes["default"].string,
  titleDescription: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  type: _propTypes["default"].string,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  error: _propTypes["default"].string,
  isInputFocused: _propTypes["default"].bool,
  hideArrows: _propTypes["default"].bool,
  maxFeedbackLength: _propTypes["default"].number
}), _FieldComponent)) || _class;
var _default = exports["default"] = FieldComponent;
//# sourceMappingURL=index.js.map